import { Dispatch, SetStateAction, useState } from "react";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import ModalComponent from "../../../../Modais";
import {
    faAt,
    faHome,
    faPaperclip,
    faExpand,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DOMPurify from "dompurify";
import moment from "moment";
import { IEmail } from "../../../../../Interfaces/Geral/Triagem";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Table";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { ListarClienteRespostaEmailTriagemController } from "../../../../../Controllers/Geral/Email/EmailController";

interface IEmailsRespostas {
    setShow: Dispatch<SetStateAction<boolean>>;
    ID_EMAIL: number;
}

export default function EmailsRespostas(props: IEmailsRespostas) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstClienteRespostaEmail,
        loading: lstClienteRespostaEmailLoading,
    } = useAsyncEffect(async () => {
        if (props.ID_EMAIL) {
            return ListarClienteRespostaEmailTriagemController(props.ID_EMAIL);
        }
    }, [props.ID_EMAIL]);

    function row(cell: any, row: IEmail) {
        const cleanHTML = DOMPurify.sanitize(row.DS_MENSAGEM);

        return (
            <div>
                <div className="card">
                    <div className="card-body row">
                        <div className="col-12 d-flex flex-wrap justify-content-between align-items-center mb-2">
                            <div className="d-flex flex-column">
                                <h4 className="mb-0">{row.DS_ASSUNTO}</h4>
                                <h5 className="text-muted text-break">
                                    {row.DS_REMETENTE}
                                </h5>
                            </div>
                            <div>
                                <span
                                    className="label label-light-dark label-inline mr-3"
                                    style={{ height: "auto" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faAt}
                                        className="mr-1"
                                    />{" "}
                                    {row.CONTA_REMETENTE}
                                </span>
                            </div>
                        </div>
                        <aside className="col-12 col-lg-4">
                            <div className="d-flex flex-lg-column flex-wrap">
                                <div className="mb-2 mr-5">
                                    <div className="d-block font-weight-bold mb-1">
                                        Data de envio
                                    </div>
                                    <div className="label label-light-primary label-inline mr-2 my-1">
                                        {moment(row.DT_CADASTRO).format("lll")}
                                    </div>
                                </div>
                                <div className="mb-2 mr-5">
                                    <h6 className="mb-0">{row.DS_CONTATO}</h6>
                                    <span className="text-muted">
                                        {row.DS_CONTA}
                                    </span>
                                </div>
                                {row.DS_PRODUTO && (
                                    <div className="d-flex flex-nowrap align-items-center mb-2 mr-5">
                                        <div className="symbol symbol-45 symbol-light-danger">
                                            <div className="symbol-label">
                                                <FontAwesomeIcon
                                                    icon={faHome}
                                                    size="lg"
                                                />
                                            </div>
                                        </div>
                                        <div className="text-left ml-2">
                                            <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                {row.DS_PRODUTO}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {row.ANEXOS?.length > 0 && (
                                    <div className="d-flex flex-wrap w-100">
                                        {row.ANEXOS?.map((anexo) => (
                                            <a
                                                className="btn btn-clean d-flex justify-content-between align-items-center g-2"
                                                href={anexo.DS_LINK_DRIVE}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faPaperclip}
                                                />
                                                {anexo.DS_DOCUMENTO?.length > 20
                                                    ? anexo.DS_DOCUMENTO?.substring(
                                                          0,
                                                          20
                                                      ) + "..."
                                                    : anexo?.DS_DOCUMENTO}
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </aside>
                        <main className="col-12 col-lg-8 mt-4 mt-lg-0">
                            <div className="border border-dark h-100 position-relative">
                                <button
                                    className="btn btn-primary rounded-0 position-absolute"
                                    style={{ right: "-1px", top: "-1px" }}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            Component: () => (
                                                <div className="bg-light p-5 rounded">
                                                    <h3 className="font-weight-bolder">
                                                        {row.DS_ASSUNTO}
                                                    </h3>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: cleanHTML,
                                                        }}
                                                        className="modalHtml"
                                                    ></div>
                                                </div>
                                            ),
                                            noFooter: true,
                                            noHeader: true,
                                            scrollable: true,
                                            size: "xl",
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faExpand}
                                        className="mr-2"
                                    />{" "}
                                    Expandir
                                </button>
                                <iframe
                                    title={`emailPreview-${row.ID_EMAIL}`}
                                    className="emailPreview"
                                    src={`about:blank`}
                                    srcDoc={cleanHTML}
                                ></iframe>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_REMETENTE",
            text: "Emails",
            formatter: row,
        },
    ];

    return (
        <>
            <Table
                data={lstClienteRespostaEmail ?? []}
                keyField="ID_EMAIL"
                columns={columns}
                loading={lstClienteRespostaEmailLoading}
                noDataIndication={
                    <div className="text-muted text-center">
                        Nenhum email para triar
                    </div>
                }
                remote={{ pagination: true }}
                bordered={false}
                noHover
                noSearch
            />
            <ModalComponent
                setShow={setShow}
                show={show}
                ModalComponent={modal}
            />
        </>
    );
}
